import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsappButton from '../ui/WhatsappButton';

const Layout = ({ children }) => {
  useEffect(() => {
    // Siteyi hep karanlık temada çalıştırmak için
    document.documentElement.classList.add('dark');
  }, []);

  return (
    <div className="flex flex-col min-h-screen dark:bg-dark dark:text-light">
      <Header />
      <main className="flex-grow pt-24">
        {children}
      </main>
      <WhatsappButton />
      <Footer />
    </div>
  );
};

export default Layout;
